export default "__VITE_ASSET__uXJ7xGHQ__"